import styled from 'styled-components';

export const Text = styled.a`
  font-size: 14px;
  font-weight: 800;
  margin-left: 110px;
  cursor: pointer;
`;
